import { useEffect, useRef, useState } from "react";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import { IoMdEye } from "react-icons/io";
import { MdFilterAlt } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { BiSolidBot } from "react-icons/bi";
import { Link } from "react-router-dom";
import CustomerSupportIcon from "../helper/images/customer.png";
import { useAuth } from "../context/AuthContext";
import UserImage from "../helper/images/customer.png";
import socket from "../helper/socket";
import { useTranslation } from "../hooks/useTranslation";

function Queries({ chats, isLoading, handleView , search , setSearch }) {
  const { t } = useTranslation();
  return (
    <div className="mt-6 bg-white border rounded-[10px] overflow-hidden p-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="font-semibold">{t("Queries").title}</h3>
        {/* <div className="relative w-full max-w-[300px]">
          <CiSearch
            size={20}
            className="absolute left-3 top-3 text-green-600"
          />
          <input
            type="text"
            placeholder={t("Queries").searchPlaceholder}
            className="w-full pl-10 pr-4 py-2 rounded-full border border-gray-300"
          />
        </div> */}

        <div className="relative">
              <CiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-lg" />
              <input
                type="text"
                placeholder= {t("Queries").columns.placeholder}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-10 pr-3 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-400 w-[280px]"
              />
            </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-left">
          <thead className="bg-[#FFFAF2] ">
            <tr className="">
              <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                {t("Queries").columns.requestId}
              </th>
              <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                {t("Queries").columns.guestName}
              </th>
              <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                {t("Queries").columns.bookingId}
              </th>

              <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                {t("Queries").columns.requestType}
              </th>

              <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                {t("Queries").columns.reason}
              </th>
                  {/* <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                    {t("Queries").columns.status}
                  </th> */}
              <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                {t("Queries").columns.actions}
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="7" className="py-5 text-center text-gray-500">
                  {t("Queries").messages.loading}
                </td>
              </tr>
            ) : chats.length === 0 ? (
              <tr>
                <td colSpan="7" className="py-5 text-center text-gray-500">
                  {t("Queries").messages.noChats}
                </td>
              </tr>
            ) : (
              chats?.map((chat) => (
                <tr
                  key={chat._id}
                  className={`border-t ${
                    chat?.unreadCount > 0 ? "bg-[#e7ffe8] font-semibold" : ""
                  }`}
                >
                  <td className="py-3 px-4">#{chat._id.slice(-6)}</td>
                  <td className="py-3 px-4">{chat.createdBy?.name || "N/A"}</td>
                  <td className="py-3 px-4">
                    {chat.contextInfo?.bookingId ||
                      chat.contextInfo?.orderId ||
                      chat.contextInfo?.reservationId ||
                      "N/A"}
                  </td>
                  <td className="py-3 px-4">
                    {chat?.contextType === "order"
                      ? "Restaurant Order"
                      : chat?.contextType === "table"
                      ? "Table Booking"
                      : "Hotel Booking"}
                  </td>
                  <td className="py-3 px-4">{chat.reason}</td>
                  {/* <td className="py-[20px] px-[16px] ">
                    <div className="px-[20px] py-2 max-w-[130px] text-white bg-[#FF9D00] font-normal rounded-full text-center text-sm">
                      {t("Queries").status.pending}
                    </div>
                  </td> */}

                  <td className="py-3 px-4">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => handleView(chat)}
                        className="bg-gray-100 p-2 rounded-full"
                      >
                        <IoMdEye size={18} />
                      </button>

                      {chat?.unreadCount > 0 && (
                        <span className="text-sm text-red-500 font-medium ">
                          {chat.unreadCount} {t("Queries").messages.new}
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Queries;
